import { connect } from "react-redux";
import ContactSupport from "../components/contact-support";
import { getCommunications, getGroupBettingPools, getSession } from "../selectors";
import FriendlyMessage from "../components/friendly-message";
import GroupBettingPool from "../components/group-betting-pool";
import Loading from "../components/loading";
import pure from "../components/higher-order/pure";
import React from "react";
import states from "../states";

function GroupBettingPools({ communications, groupBettingPools, session }) {
  var pools = groupBettingPools.valueSeq().map(pool => <GroupBettingPool groupBettingPool={pool} key={pool.get("id")} />);
  var empty = null;
  var loading = communications.getIn(["fetchOpenGroupBettingPools", "state"]) === "in progress";
  if (loading) {
    empty = <Loading />;
  } else if (groupBettingPools.count() === 0) {
    empty = (
      <FriendlyMessage buttonText="View Tournaments" title="No pools scheduled today." url="/tournaments">
        Check out our current tournaments:
      </FriendlyMessage>
    );
  }

  var canPlayPlayerPools = session.get("abilities").contains("enter player pools");
  if (!canPlayPlayerPools) {
    pools = null;
    empty = "asdf";

    var state = session.getIn(["billing_address", "state"]);
    var fullState = "your";
    var stateInfo = states.filter(s => s.abbr === state)[0];
    if (stateInfo !== undefined) {
      fullState = stateInfo.name;
    }
    var fullMessage = `Sorry, ${fullState} residents are not eligible for Player Pools.`;

    empty = <ContactSupport message={fullMessage} subtle />;
  }

  return (
    <div>
      <div className="l-main l-row">
        <div className="l-wrapper">
          <div className="l-content l-content--80-percent">

            <h1 className="text-center">
              Player Pool Tickets
            </h1>

            <div className="group-betting-pool_table">
              {pools}
            </div>

            {empty}

          </div>
        </div>
      </div>
    </div>
  );
}

function select(state, props) {
  return {
    communications: getCommunications(state, props),
    groupBettingPools: getGroupBettingPools(state, props),
    session: getSession(state, props)
  };
}

export default connect(select)(pure(GroupBettingPools));
